// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"1f5bdce8","744":"64c670ec"}[chunkId] + ".chunk.js";
};